export enum ToolsType {
  DRAW_POLYGON = "draw_polygon",
  DRAW_FREEHAND_POLYGON = "draw_freehand_polygon",
  DRAW_SQUARE = "draw_square",
  UPLOAD_AREA = "upload_area",
  NONE = "none",
}
